function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 8,
  r: 8,
  fill: "#A3C939"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M3.69 5.96a.738.738 0 0 0-.737.737V9.81a.738.738 0 1 0 1.475 0V6.697a.738.738 0 0 0-.737-.737zM12.31 5.96a.738.738 0 0 0-.739.737V9.81a.738.738 0 1 0 1.475 0V6.697a.738.738 0 0 0-.737-.737zM9.814 3.294l.55-.91-.463-.28-.563.935a3.308 3.308 0 0 0-1.32-.273c-.469 0-.915.097-1.32.273l-.563-.934-.462.279.549.91A3.317 3.317 0 0 0 4.7 5.96h6.634a3.317 3.317 0 0 0-1.52-2.666zM6.516 4.7a.337.337 0 1 1 0-.675.337.337 0 0 1 0 .675zm2.968 0a.337.337 0 1 1 0-.675.337.337 0 0 1 0 .675z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M9.814 3.294l.55-.91-.463-.28-.563.935a3.308 3.308 0 0 0-1.32-.273H8.01V5.96h3.325a3.317 3.317 0 0 0-1.52-2.666zM9.484 4.7a.337.337 0 1 1 0-.675.337.337 0 0 1 0 .675zM4.68 11.636h1.314v1.647a.738.738 0 1 0 1.475 0v-1.647h1.026v1.647a.738.738 0 0 0 1.475 0v-1.647h1.35V6.454H4.68v5.182z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M8.01 6.454v5.182h.485v1.647a.738.738 0 0 0 1.475 0v-1.647h1.35V6.454H8.01z"
}));

var SvgAndroid = function SvgAndroid(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAndroid, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/android.a39f33ef.svg";
export { ForwardRef as ReactComponent };